import { TablelistProApi } from '@lib/api'
import { mutate } from 'swr'
import { User } from 'types/model'
import { AuthResponse, SignupFormValues } from 'types/model/auth'
import {
  clearAuthToken,
  clearSessionUser,
  setAuthToken,
  setSessionUser,
} from '@utils/auth'
import googleTagManagerClient from '@utils/analytics/gtm'

class AuthApi extends TablelistProApi<User> {
  constructor() {
    super('/auth')
  }

  async signup(data: {
    email: string
    firstName: string
    lastName: string
    password: string
  }) {
    const response = await this.post<
      AuthResponse,
      Omit<SignupFormValues, 'confirmPassword'>
    >(`${this.basePath}/register`, data)
    setAuthToken(response.token)
    setSessionUser(response.user.id)
    await mutate('/user/me')
    return response
  }

  async login(email: string, password: string) {
    const response = await this.post<
      AuthResponse,
      { email: string; password: string }
    >(`${this.basePath}/login`, {
      email,
      password,
    })
    setAuthToken(response.token)
    setSessionUser(response.user.id)
    await mutate('/user/me')

    googleTagManagerClient.startSession()

    return response
  }

  async logout() {
    clearAuthToken()
    clearSessionUser()
    await mutate('/user/me')

    googleTagManagerClient.startSession()
  }

  async forgotPassword(email: string) {
    const response = await this.post<{ message: string }, { email: string }>(
      `${this.basePath}/forgot`,
      { email }
    )

    return response
  }
}

export const authApi = new AuthApi()
